import * as React from 'react';
import Page from './../components/Page';
import {Button, ButtonGroup, Card, CardBody, Col, Row, Table,} from 'reactstrap';
import BasePage from './BasePage';
import Global, {DD_MM_YYYY_HH_MM_SS} from '../utils/Global';
import ConfirmDialog from '../components/modal/ConfirmDialog';
import SearchInput from '../components/SearchInput';

import Pagination from '../components/Pagination';
import * as queryString from 'query-string/index';
import {deleteParam, isEmpty, parseDate} from '../utils/Utilities';
import ActiveLabel from '../components/Widget/ActiveLabel';
import label from 'enqc-utilities/src/label/Label'
import {delegateObjectsForSelection, navigate} from "enqc-utilities/src/utils/Utilities";
import DropdownInput from "../components/form/DropdownInput";
import PrimaryCardHeader from "../components/Widget/PrimaryCardHeader";
import ModelDetailPage from "./ModelDetailPage";
import FormBuilderDetailPage from "./FormBuilderDetailPage";

import {FaInfo, MdDetails, FaTasks} from "react-icons/all";
import ComponentGroupDetailPage from "./ComponentGroupDetailPage";

const tableTypes = ['', 'bordered', 'striped', 'hover'];

class ModelPage extends BasePage{



    constructor(props) {
        super(props);
        let models  = new Array();
        this.state ={
            models : models,
            model:{},
            modalDeleteConfirm:false,
            ascending:false,
            sortir:'jt.created',
            search:"",
            page :queryString.parse(this.props.query).page?queryString.parse(this.props.query).page:1,
            totalPage:0,
            totalElement:0,
            pageElement:0,
        }
    }

    componentDidMount() {
        super.componentDidMount();
        this.fetchAll(this.state.ascending, this.state.sortir, this.state.search, this.state.page, true)
    }
    componentWillReceiveProps(props, nextContext) {
        if(props!=this.props){
            this.setState({
                page:queryString.parse(props.query).page?queryString.parse(props.query).page:1
            }, () => {
                this.fetchAll(this.state.ascending, this.state.sortir, this.state.search, this.state.page, true)
            })
        }
    }



    fetchAll = (ascending, sortir, search, page, progressing) => {
        this.get(Global.API.MODELS, {
            params:{
                ascending:ascending,
                sortir:sortir,
                search:search,
                page: page-1
            }
        }, null, res=>{
            if(res.code === 200){
                this.setState({
                    models : res.data,
                    totalPage: res.totalPage,
                    totalElement: res.totalElement,
                    pageElement: res.pageElement,
                })
            }
        },progressing, true);
    }

    confirmDelete = () =>{
        this.setState({
            modalDeleteConfirm:true
        })
    }

    delete = () => {
        this.setState({
            modalDeleteConfirm:false
        }, () => {
            this.get(Global.API.MODEL_DELETE+"/"+this.state.model.id, null, null, res=>{
                if(res.code===200){
                    this.successToast(res.message)
                    this.setState({
                        category:null
                    }, () => {
                        this.fetchAll(this.state.ascending, this.state.sortir, this.state.search, this.state.page, true)
                    })
                }
            }, true, true);
        })
    }

    closeDialog = () =>{
        this.setState({
            modalAddConfirm:false,
            modalDeleteConfirm:false
        })
    }

    refreshModel = (ascending, sortir, progressing) => (
        this.setState({
            ascending:ascending,
            sortir:sortir
        }, () => {
            this.fetchAll(this.state.ascending, this.state.sortir, this.state.search, this.state.page, progressing)
        })
    )

    render() {
        var i = 0 ;
        let {ascending, sortir} = this.state
        let orderOptions = delegateObjectsForSelection(
            {name:label.SystemType, field:'jt.systemType'},
            {name:label.Suggestion, field:'jt.suggestion'},
            {name:label.InspectionDone, field:'jt.inspectionCount'},
            {name:label.Created, field:'jt.created'},
            {name:label.Updated, field:'jt.updated'}
        )
        let ascendingOptions = delegateObjectsForSelection( {name:label.Descending, field:false}, {name:label.Ascending, field:true})


        return (
            <Page
                title={label.ModelList}
                breadcrumbs={[{ name: label.Model, active: true }]}
                className="TablePage"
            >
                {super.render()}
                <ConfirmDialog
                    showing={this.state.modalDeleteConfirm}
                    title={label.DeleteConfirmationTitle}
                    message="Do you want to delete this model item from your list ?"
                    okCallback={this.delete}
                    cancelCallback={this.closeDialog}/>
                <Row key={1}>
                    <Col>
                        <Card className="mb-6">
                            <PrimaryCardHeader content={label.Model}/>
                            <CardBody>
                                <Row>
                                    <Col md={6}>
                                        <ButtonGroup className="d-flex w-100">
                                            <DropdownInput
                                                title={label.SortBy}
                                                options={orderOptions}
                                                onSelect={(item) => {
                                                    this.refreshModel(ascending, item.field, true)
                                                }}
                                                onReset={() => {
                                                    this.refreshModel(ascending, "jt.created", true)
                                                }}/>
                                            &nbsp;&nbsp;&nbsp;
                                            <DropdownInput
                                                options={ascendingOptions}
                                                onSelect={(item) => {
                                                    this.refreshModel(item.field, sortir, true)
                                                }}
                                                onReset={() => {
                                                    this.refreshModel(true, sortir, true)
                                                }}/>
                                        </ButtonGroup>
                                    </Col>
                                    <Col md={4}>
                                        <SearchInput
                                            placeholder={label.SearchModelByNameSystemAndPart}
                                            value={this.state.search}
                                            onChange={e=>{
                                                this.setState({
                                                    search:e.target.value
                                                }, () => {
                                                    if(this.state.search===''){
                                                        deleteParam(this.props, 'page')
                                                    }
                                                })
                                            }}
                                            onEnter={e=>{
                                                if(this.state.search!==''){
                                                    deleteParam(this.props, 'page')
                                                }
                                            }}
                                        />
                                    </Col>
                                    <Col md={2}>
                                        <ButtonGroup className="float-right">
                                            <Button color="primary" onClick={e=>{
                                                this.props.history.push('/modelDetail')
                                            }}>&nbsp;+&nbsp;{label.AddModel}</Button>
                                        </ButtonGroup>
                                    </Col>
                                </Row>
                                <Row>
                                    <Table responsive hover>
                                        <thead>
                                        <tr>
                                            <th>#</th>
                                            <th>
                                                {label.SystemType}
                                            </th>
                                            <th>{label.GroupForm} / {label.ReleaseVerificationGroupForm}</th>
                                            <th className="text-center">{label.RectifierAndControllerSize} / {label.Component}</th>
                                            <th>{label.Publication}</th>
                                            <th>{label.Updated}</th>
                                        </tr>
                                        </thead>
                                        <tbody>
                                        {
                                            this.state.models.map((item, index)=>(
                                                <tr key={index}>
                                                    <th scope="row">
                                                        {((this.state.page-1)* this.state.pageElement)+(++index)}
                                                    </th>
                                                    <td className="fs-7">
                                                        {item.modelCategory.name}
                                                        <br/>
                                                        <a href={ModelDetailPage.ENDPOINT+'?id='+item.id}>{item.systemType}</a>
                                                        <br/>
                                                        <span className="fs-7">{label.PN}:</span><span className="font-italic text-underline h5">{item.partNumber}</span>
                                                    </td>
                                                    <td className="justify-content-center align-content-center align-items-center">
                                                        <a href={FormBuilderDetailPage.ENDPOINT+'?id='+item.groupForm.id}>{item.groupForm?item.groupForm.name:"N/A"}</a>
                                                        {!isEmpty(item.releaseVerificationGroupForm)?(
                                                            <React.Fragment>
                                                                <br/>
                                                                <a href={FormBuilderDetailPage.ENDPOINT+'?id='+item.releaseVerificationGroupForm.id}>{item.releaseVerificationGroupForm.name}</a>
                                                            </React.Fragment>
                                                        ):(
                                                            <React.Fragment>
                                                                <br/>
                                                                <span>N/A</span>
                                                            </React.Fragment>
                                                        )}
                                                    </td>
                                                    <td className="text-center justify-content-center align-content-center align-items-center">
                                                        <Button
                                                            disabled={true} className="rounded-lg btn-disabled align-items-center fs-6" size="sm">{item.sizeOfRectifierControllerSerialNumber}&nbsp;<FaInfo className="fs-7"/></Button>
                                                        &nbsp;&nbsp;
                                                        <Button
                                                            size="sm"
                                                            className="rounded-lg btn-outline-dark btn-light text-dark align-items-center fs-6"
                                                            onClick={(e) => {
                                                                e.preventDefault()
                                                                navigate(this.props, ComponentGroupDetailPage.ENDPOINT+"?id="+item.componentGroup.id)
                                                            }}>
                                                            {item.componentGroup.componentSize}&nbsp;<FaTasks className="fs-7"/>
                                                        </Button>
                                                    </td>
                                                    <td className="justify-content-center align-content-center align-items-center">
                                                        <ActiveLabel
                                                            active={item.published}
                                                            trueLabel={label.Published}
                                                            falseLabel={label.Unpublished}
                                                            singleLabel={item.situationInfo}/>
                                                    </td>
                                                    <td className="justify-content-center align-content-center align-items-center">{parseDate(item.updated, DD_MM_YYYY_HH_MM_SS)}</td>
                                                </tr>
                                            ))
                                        }
                                        </tbody>
                                    </Table>
                                </Row>
                            </CardBody>
                            <Pagination {...this.props} currentPage={parseInt(this.state.page)} pageCount={this.state.totalPage} />
                        </Card>
                    </Col>
                </Row>
            </Page>
        );
    }
};

export default Object.assign(ModelPage, {ENDPOINT : "/models"})
